import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductsService } from "src/app/services/products.service";
import { HelpersService } from "src/app/services/helpers.service";
import { RentalsService } from "src/app/services/rentals.service";
import { ConfirmationService, MenuItem } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-add-edit-price-group',
  templateUrl: './add-edit-price-group.component.html',
  styleUrls: ['./add-edit-price-group.component.scss']
})
export class AddEditPriceGroupComponent implements OnInit {

  @Input() priceGroup;
  @Output() close = new EventEmitter();

  public editing : boolean = false;
  public products: any = [];
  public searchResult: any = [];
  public savingPriceGroup : boolean = false;
  public removingPriceGroup : boolean = false;
  public loading : boolean = false;
  

  constructor(
    private productsService : ProductsService,
    private helpersService : HelpersService,
    private rentalsService : RentalsService,
    private confirmationService : ConfirmationService,
    private translate : TranslateService
  ) { }

  ngOnInit() {
    console.log(this.priceGroup);
    if(this.priceGroup.priceGroupID){
      this.editing = true;
      this.priceGroup.allocatedTimePrice.forEach(x=>{
        if(x.quantity == 0 && x.rentalRateID ===0 ){
          x.quantity = 1;
        }
      });
    }
  }

  isValid(){
    return this.priceGroup.name !== undefined && this.priceGroup.name.length > 0;
  }

  searchProducts(event) {
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (product.SystemSKU !== null &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
          -1) ||
        (product.ManufacturerSKU !== null &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase()
          ) > -1)
      );
    });
    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = 1;
      delete product.PartnerID;
      return product;
    });

    if (results.length > 0) {
      this.searchResult = results;
    } else {
      this.searchExternal(event);
    }
  }

  searchExternal(event) {
    this.productsService
      .searchProduct(this.helpersService.getPartnerId(), event.query)
      .subscribe((results) => {
        this.searchResult = results.map((item) => {
          return {
            ID: item.ID,
            SKU: item.Description,
            Name: item.Data,
            Quantity: 1,
          };
        });
      });
  }


  linkSku(sku, timeUnit) {
    console.log(sku);
    console.log(timeUnit);
    timeUnit.internalProductID = sku.ID;
    timeUnit.sku = sku.SKU;
    timeUnit.name = sku.Name;
    timeUnit.rate = 0;
    timeUnit.newSku = null;
  }

  savePriceGroup(){
    this.savingPriceGroup = true;
    if(this.priceGroup.priceGroupID){
      //Update
      this.rentalsService.updateRentalPriceGroup(this.priceGroup).subscribe(res=>{
        this.savingPriceGroup = false;
        this.close.emit();
      },err=>{
        this.savingPriceGroup = false;
      })
    }else{
      //Save new
      this.rentalsService.addRentalPriceGroup(this.priceGroup).subscribe(res=>{
        this.savingPriceGroup = false;
        this.close.emit();
      },err=>{
        this.savingPriceGroup = false;
      })
    } 

  }

  removeSKU(allocatedTimePrice){
    allocatedTimePrice.sku = null;
    allocatedTimePrice.name = null;
    allocatedTimePrice.internalProductID = 0;
    allocatedTimePrice.rate = 0;
    allocatedTimePrice.quantity = 1;
  }

  removePriceGroup(){
    this.confirmationService.confirm({
      key: 'add_edit_price_group',
      rejectLabel: this.translate.instant("general.no"),
      acceptLabel: this.translate.instant("general.yes"),
      header: this.translate.instant("bikeshop.rentals.pricing.remove_price_group"),
      message: this.translate.instant("bikeshop.rentals.pricing.remove_price_group_message"),
      accept: () => {
        this.removingPriceGroup = true;
        this.rentalsService.updateRentalPriceGroup({...this.priceGroup, isActive : 0}).subscribe(res=>{
          this.removingPriceGroup = false;
          this.close.emit();
        },err=>{
          this.removingPriceGroup = false;
        })

      },
    });
  }

}
